export default __webpack_public_path__ + "app/images/theme-images/dark/upload-file-btn/icon-20-attach-sharp@2x.webp";